// extracted by mini-css-extract-plugin
export default {"main":"Approval_main__bTIFR","body":"Approval_body__Gx5Vv","list":"Approval_list__Lc8B2","btn":"Approval_btn__e7MUS","header":"Approval_header__qBs+5"};